import React, { Component } from "react";
import { Form } from "antd";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { signUp, socialLogin } from "../../../actions/auth";
import { compose } from "redux";
import { withFirestore } from "react-redux-firebase";


import Register from "./Register";
import { RegisterationFields as Fields } from "../../common/labels/forms";

class index extends Component {
  state = {
    passwordError: null
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.password !== values.passwordConfirmation) {
          this.setState({
            passwordError: "Password do not match"
          })
        } else {
          this.props.signUp(values)
          this.setState({
            passwordError: null
          })
          this.props.form.resetFields();
        }
      }
    });
  };

  render() {
    if (this.props.auth.uid) return <Redirect to="/campaigns" />;
    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        <Register
          getFieldDecorator={getFieldDecorator}
          Fields={Fields}
          handleSubmit={this.handleSubmit}
          state={this.state}
          socialLogin={this.props.socialLogin}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ firebase, authError }) => {
  return {
    auth: firebase.auth,
    authError
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    signUp: creds => dispatch(signUp(creds, ownProps)),
    socialLogin: provider => dispatch(socialLogin(provider, ownProps))
  };
};

const WrappedIndex = Form.create({ name: "register" })(index);

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(WrappedIndex);
